import React, {useEffect, useState} from 'react';
import SentenceForm from "../../components/common/SentenceForm";
import Container from "@material-ui/core/Container";
import {makeStyles} from "@material-ui/core";
import ScrollableAnchor from "react-scrollable-anchor";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {useRecoilState, useRecoilValue, useSetRecoilState} from "recoil";
import {answerState, menuCheckSelector, selectedMenuItemState, surveyDataState} from "../../state/globalState";
import {getCommCode} from "../../lib/api/code";

const useStyles = makeStyles(theme => ({
    formControl: {
        minWidth: 120,
        margin: "15px 0"
    },
    date: {
        width: "160px",
        padding: "8px",
        margin: "10px 0"
    }
}));

/**
 * 설문 문항 컴포넌트
 */
const Survey4 = (props) => {
    const surveyData = useRecoilValue(surveyDataState);
    const [answer, setAnswer] = useRecoilState(answerState);
    const [natCodeList, setNatCodeList] = useState([]);
    const setSelectedMenuItem = useSetRecoilState(selectedMenuItemState);
    const setMenuCheck = useSetRecoilState(menuCheckSelector);
    const dsptNatGcd = answer.dsptNatGcd; // 파견국가
    const dsptStartDt = answer.dsptSttDt; // 파견국가
    const dsptEndDt = answer.dsptEndDt; // 파견국가
    const natlCd = answer.natlGcd; // TODO 테스트 후 삭제
    const [isError, setIsError] = React.useState(false);
    const [errorMsg, setErrorMsg] = React.useState('');
    const [startDate, setStartDate] = useState(new Date());
    const classes = useStyles();

    let parentCompRef = props.compRef;

    const getCommCodeList = async (gropCd) => {
        const { data } = await getCommCode(gropCd)
        setNatCodeList(data.payload);
    };

    useEffect(() => {
        getCommCodeList("CO034");
    }, []);

    useEffect(() => {
        setSelectedMenuItem('SURVEY_11');

        if (dsptNatGcd && dsptStartDt && dsptEndDt) {
            setMenuCheck(true);
        } else {
            setMenuCheck(false);
        }
    }, [dsptNatGcd, dsptStartDt, dsptEndDt])

    const natOptions = natCodeList.filter(item => item.commDetlsCd !== 'CO0340KR');

    const handleInputAnswer = (e, column) => {
        const { value } = e.target;

        const newState = {
            ...answer,
            [column]: value
        }
        setAnswer(newState);
    };

    const handleNatChange = (event, newValue) => {
        setAnswer({
            ...answer,
            [surveyData[11].column]: newValue ? newValue.commDetlsCd : ''
        });
    };

    const addRefs = (e) => {
        parentCompRef[11] = e;
    };


    return (
        <>
            <ScrollableAnchor id={"11"}>
                <div>
                <Container style={{background: 'transparent', marginBottom: '10px'}}>
                    <SentenceForm
                        title={surveyData[11].title}
                        sentences={surveyData[11].questions}
                        step={11}
                    />
                    <div className="textFieldContainer">
                        <Autocomplete
                            id="dsptNatGcd-autocomplete"
                            options={natOptions}
                            getOptionLabel={(option) => option.detlsCdNm || ''}
                            getOptionSelected={(option, value) => option.commDetlsCd === value.commDetlsCd}
                            value={natOptions.find(item => item.commDetlsCd === dsptNatGcd) || null}
                            onChange={handleNatChange}
                            style={{width: 250, margin: "15px 0"}}
                            renderInput={(params) => (
                                <TextField {...params} label="파견국가" variant="filled" />
                            )}
                        />
                        <br />
                        <label>파견 시작(예정)일</label><br/>
                        <input
                            className={classes.date}
                            type="date"
                            max="9999-12-31"
                            value={dsptStartDt}
                            onChange={(e) => handleInputAnswer(e, "dsptSttDt")}
                        />
                        <br/>
                        <label>파견 종료(예정)일</label><br/>
                        <input
                            className={classes.date}
                            type="date"
                            max="9999-12-31"
                            value={dsptEndDt}
                            onChange={(e) => handleInputAnswer(e, "dsptEndDt")}
                        />
                    </div>
                    {/*<div className="textFieldContainer">*/}
                    {/*    <TextField*/}
                    {/*        label="여기에 답변을 입력하십시오."*/}
                    {/*        placeholder=""*/}
                    {/*        margin="none"*/}
                    {/*        error={isError}*/}
                    {/*        helperText={errorMsg}*/}
                    {/*        value={ssnNo}*/}
                    {/*        onChange={(e) => handleInputAnswer(e, 'SSN_NO')}*/}
                    {/*        inputRef={addRefs}*/}
                    {/*    />*/}
                    {/*</div>*/}
                </Container>
                </div>
            </ScrollableAnchor>
        </>
    );
};

export default Survey4;
